import * as React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../store/SettingSlice';
import $ from 'jquery';
import * as JSTool from '../store/JSTool';

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import { Autoplay, EffectFade, EffectCoverflow, Mousewheel } from 'swiper/modules';

import NavView from '../component/NavView';
import LeftFloatView from '../component/LeftFloatView';
import RightFloatView from '../component/RightFloatView';
import SubmitEmailAlert from '../component/SubmitEmailAlert';
import CookieView from '../component/CookieView';

import Page0 from './Page0';
import Page1 from './Page1';
import Page2 from './Page2';
import Page2_2 from './Page2_2';
import Page3 from './Page3';
import Page4 from './Page4';
import Page5 from './Page5';
import Page6 from './Page6';
import Page7 from './Page7';
import Footer from '../component/Footer';

export default function HomePage(props) {
    const dispatch = useDispatch();
    const settingData = useSelector(state => state.settingData);

    const [swiper, setSwiper] = React.useState(null);
    let swp = null;

    React.useEffect(() => {
        if (settingObj.isStellars) {
            dispatch(settingActions.setStellars(false));

            // $("#home_page_view").animate({
            //     scrollTop: $('#scroll_to5').offset().top + $(`#home_page_view`).scrollTop()
            // }, 0);

            var instance = $('#home_page_sp')[0].swiper;
            instance.slideTo(3, 0, false);
        }else{
            // checkShowEmailAlert();
        }
    }, []);

    function checkShowEmailAlert() {
        let email = JSTool.getLocalString('submit_email');
        if (JSTool.isEmpty(email)) {
            setTimeout(() => {
                dispatch(settingActions.showRegisterAlert(true));
            }, 300);
        }
    }

    function topTap(){
        if(swiper){
            swiper.slideTo(0);
        }
    }

    return (
        <Stack sx={{
            width: 1,
            height: settingData.innerHeight,
            userSelect: 'none',
        }}>

            {/* 1.滚动 */}
            {/* <Stack
                id='home_page_view'
                sx={{
                    overflowX: 'hidden',
                    overflowY: 'scroll',
                }}>
                <Stack
                    sx={{
                        width: 1,
                        minWidth: '1200px',
                        backgroundImage: `url(${JSTool.getImgPath('test1.png')})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'top center',
                        backgroundSize: 'cover',
                        position: 'relative',

                    }}>
                    <Page0 anchorId='scroll_to0' />
                    <Page1 anchorId='scroll_to1' />
                    <Page2_2 anchorId='scroll_to2' />
                    <Page3 anchorId='scroll_to3' />
                    <Page4 anchorId='scroll_to4' />
                    <Page5 anchorId='scroll_to5' />
                    <Page6 anchorId='scroll_to6' />
                    <Page7 anchorId='scroll_to7' />
                    <Footer />
                </Stack>
            </Stack> */}

            {/* 2.翻页 */}
            <Swiper
                id='home_page_sp'
                className="mySwiper"
                direction={'vertical'}
                slidesPerView={1}
                mousewheel={true}
                modules={true && [Mousewheel]}
                resistanceRatio={0}
                onSwiper={(sp) => {
                    setSwiper(sp);
                    if (settingObj.scrollToRole) {
                        settingObj.scrollToRole = false;
                        sp.slideTo(2, 0, false);
                    }
                    setTimeout(() => {
                        JSTool.saveLocalString('hideLoadingView', 'false');
                    }, 300);
                }}
                onActiveIndexChange={(sp) => {
                    dispatch(settingActions.setNavIndex(sp.activeIndex));
                }}
                style={{
                    width: '100%',
                    height: '100%',
                }}>

                <SwiperSlide style={{ overflow: 'hidden', width: '100%', height: '100%' }}> <Page0 anchorId='scroll_to0' /></SwiperSlide>
                <SwiperSlide style={{ overflow: 'hidden', width: '100%', height: '100%' }}> <Page4 anchorId='scroll_to1' /></SwiperSlide>
                <SwiperSlide style={{ overflow: 'hidden', width: '100%', height: '100%' }}> <Page5 anchorId='scroll_to2' /></SwiperSlide>
                <SwiperSlide style={{ overflow: 'hidden', width: '100%', height: '100%' }}>  <Page6 anchorId='scroll_to3' /></SwiperSlide>

            </Swiper>

            <CookieView />

            <NavView />
            <LeftFloatView />
            <RightFloatView topTap={topTap}/>
        </Stack>
    );
}
